import { render, staticRenderFns } from "./ReadyForInspectionButton.vue?vue&type=template&id=1bca96c6&scoped=true&"
import script from "./ReadyForInspectionButton.vue?vue&type=script&lang=js&"
export * from "./ReadyForInspectionButton.vue?vue&type=script&lang=js&"
import style0 from "./ReadyForInspectionButton.vue?vue&type=style&index=0&id=1bca96c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca96c6",
  null
  
)

export default component.exports